import { FC } from 'react';
import { Field } from '@edikk-edikk/country-form';
import {
  buildFiledInputVariantClassName,
  FieldError,
  FieldInputPropsType,
  FieldInputSize,
  FieldLabel,
  FieldWrapper,
} from '#components/form';
import fieldInputCss from './assets/field-input.module.scss';
import { useClassNamesWithStyle } from '#base/hooks';

const FieldInput: FC<FieldInputPropsType> = ({
  name,
  type = 'text',
  id = null,
  label = null,
  isRequired = false,
  placeholder = null,
  size = null,
  variant = null,
}) => {
  const classNamesWithStyle = useClassNamesWithStyle();

  return (
    <Field
      name={name}
      type={type}
      render={({ input, meta }) => (
        <FieldWrapper>
          <FieldLabel label={label} htmlFor={id} isRequired={isRequired} />
          <input
            // eslint-disable-next-line react/jsx-props-no-spreading
            {...input}
            id={id}
            className={classNamesWithStyle(
              [
                fieldInputCss.fieldInput,
                buildFiledInputVariantClassName(variant),
                { [fieldInputCss.fieldInput_sizeLg]: size === FieldInputSize.lg },
              ],
              fieldInputCss.fieldInput_styleDefault,
              fieldInputCss.fieldInput_styleRed,
            )}
            placeholder={placeholder}
          />
          <FieldError error={meta.submitError || meta.error} />
        </FieldWrapper>
      )}
    />
  );
};

export { FieldInput };
